import { useSelector } from 'react-redux';
import { selectSelectedItem } from '@reducers/machines';
import { useTrackScreenOpened, TRACKING_EVENTS } from '@services/tracking';
import { Machine } from '@interfaces/machines';

export const useTrackMachineTimelineOpened = () => {
  const selectedItem = useSelector(selectSelectedItem) as Machine;

  useTrackScreenOpened(TRACKING_EVENTS.MACHINE_TIMELINE, () => ({
    machineId: selectedItem?.machineId ? String(selectedItem.machineId) : '',
    machineName: selectedItem?.shortName || selectedItem?.fullName || '',
    dateRange: '',
    zoomLevel: '',
  }));
};
